import { useTranslation } from 'react-i18next'
import React from 'react'

import { useForm, useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../EditableSentence'

const OPTIONS = [
  { id: 'user_id', name: 'usuário', entity: 'service_order' },
  { id: 'group_id', name: 'grupo responsável', entity: 'service_order' },
  { id: 'user.contract.group_id', name: 'grupo do usuário responsável', entity: 'service_order' },
  { id: 'checklist_id', name: 'questionário', entity: 'service_order' },
  { id: 'place_id', name: 'local/pessoa', entity: 'service_order' },
  { id: 'place.place_level_ids', name: 'nível de local', entity: 'service_order', operator: 'any' },
  {
    id: 'place.place_type_id',
    name: 'tipo de local',
    entity: 'service_order',
    single: true
  },
  { id: 'status_id', name: 'status', entity: 'event' },
  { id: 'status_id', name: 'status', entity: 'service_order' },
  { id: 'service_order.tag_id', name: 'tag', entity: 'event' },
  { id: 'tag_id', name: 'tag', entity: 'service_order' },

  // Os gatilhos "atividade recebeu/perdeu tag" despacham o mesmo tipo de registro
  // (a atividade em si, achatada) que a entidade `service_order` — mesmo motivo
  // documentado no back-elixir (`TriggerDispatcher.Actions.AssignTag`/`UpdateStatus`:
  // o registro casa por formato `%{id: _}`, não por `entity`). Por isso as condições
  // disponíveis são as mesmas de `service_order`, não as prefixadas de `event`.
  { id: 'user_id', name: 'usuário', entity: 'service_order_tag_assigned' },
  { id: 'group_id', name: 'grupo responsável', entity: 'service_order_tag_assigned' },
  { id: 'user.contract.group_id', name: 'grupo do usuário responsável', entity: 'service_order_tag_assigned' },
  { id: 'checklist_id', name: 'questionário', entity: 'service_order_tag_assigned' },
  { id: 'place_id', name: 'local/pessoa', entity: 'service_order_tag_assigned' },
  { id: 'place.place_level_ids', name: 'nível de local', entity: 'service_order_tag_assigned', operator: 'any' },
  { id: 'place.place_type_id', name: 'tipo de local', entity: 'service_order_tag_assigned', single: true },
  { id: 'status_id', name: 'status', entity: 'service_order_tag_assigned' },
  { id: 'tag_id', name: 'tag', entity: 'service_order_tag_assigned' },

  { id: 'user_id', name: 'usuário', entity: 'service_order_tag_removed' },
  { id: 'group_id', name: 'grupo responsável', entity: 'service_order_tag_removed' },
  { id: 'user.contract.group_id', name: 'grupo do usuário responsável', entity: 'service_order_tag_removed' },
  { id: 'checklist_id', name: 'questionário', entity: 'service_order_tag_removed' },
  { id: 'place_id', name: 'local/pessoa', entity: 'service_order_tag_removed' },
  { id: 'place.place_level_ids', name: 'nível de local', entity: 'service_order_tag_removed', operator: 'any' },
  { id: 'place.place_type_id', name: 'tipo de local', entity: 'service_order_tag_removed', single: true },
  { id: 'status_id', name: 'status', entity: 'service_order_tag_removed' },
  { id: 'tag_id', name: 'tag', entity: 'service_order_tag_removed' },
  { id: 'service_order.checklist_id', name: 'questionário', entity: 'event' },
  { id: 'service_order.place_id', name: 'local/pessoa', entity: 'event' },
  { id: 'service_order.user_id', name: 'usuário', entity: 'event' },
  { id: 'user.contract.group_id', name: 'grupo do usuário responsável', entity: 'event' },
  { id: 'service_order.opened', name: 'Atividade aberta', entity: 'service_order' },
  { id: 'service_order.parent.checklist_id', name: 'questionário da atividade pai', entity: 'event' },
  { id: 'service_order.parent.user_id', name: 'usuário da atividade pai', entity: 'event' },
  { id: 'service_order.parent.place_id', name: 'local/pessoa da atividade pai', entity: 'event' },
  { id: '_event_service_order_reply_value', name: 'resposta da pergunta', entity: 'event' },
  // Mesmas condições de `event` acima: `service_order_reply_upsert` (resposta editada) despacha
  // o mesmo shape de payload (`Preloaders.ServiceOrderReplies` no back-elixir aninha a Reply em
  // `record.service_order`, com `checklist`/`replies` pré-carregados igual a `Preloaders.Events`),
  // então precisa do mesmo par questionário→resposta: o seletor de questionário (`service_order.
  // checklist_id`, que alimenta `getChecklistIds` em ReplyValueCondition.js) e a condição
  // "resposta da pergunta" propriamente dita.
  { id: 'service_order.checklist_id', name: 'questionário', entity: 'service_order_reply' },
  { id: '_event_service_order_reply_value', name: 'resposta da pergunta', entity: 'service_order_reply' },
  { id: 'service_order.place.place_level_ids', name: 'nível de local', entity: 'event', operator: 'any' },
  {
    id: 'place.place_type_id',
    name: 'tipo de local',
    entity: 'event',
    single: true
  },
  { id: '_form_reply_reply_value', name: 'resposta da pergunta', entity: 'form_reply' },

  { id: 'contract.group_id', name: 'grupo', entity: 'user' },

  { id: 'form_id', name: 'formulário', entity: 'form_reply' },
  { id: 'form.checklist_id', name: 'questionário', entity: 'form_reply' },
  { id: 'place.place_level_ids', name: 'nível de local', entity: 'form_reply', operator: 'any' },

  { id: 'non_compliance.opened', name: 'Não conformidade aberta', entity: 'non_compliance' },
  { id: 'non_compliance.place_id', name: 'local/pessoa', entity: 'non_compliance' },
  {
    id: 'place.place_level_ids',
    name: 'nível de local',
    entity: 'non_compliance',
    operator: 'any'
  },

  { id: 'non_compliance.question_id', name: 'pergunta', entity: 'non_compliance' },
  { id: 'non_compliance.question.tag_ids', name: 'tag da pergunta', entity: 'non_compliance', operator: 'any' },
  { id: 'non_compliance.question.checklist_id', name: 'questionário', entity: 'non_compliance' },

  { id: 'non_compliance_event.service_order.place_id', name: 'local/pessoa', entity: 'non_compliance_event' },
  { id: 'non_compliance_event.non_compliance.question_id', name: 'pergunta', entity: 'non_compliance_event' },
  {
    id: 'non_compliance_event.non_compliance.question.tag_ids',
    name: 'tag da pergunta',
    entity: 'non_compliance_event',
    operator: 'any'
  },
  { id: 'non_compliance_event.service_order.checklist_id', name: 'questionário', entity: 'non_compliance_event' },
  { id: 'non_compliance_event.type', name: 'tipo', entity: 'non_compliance_event' },
  {
    id: 'non_compliance.place.place_level_ids',
    name: 'nível de local',
    entity: 'non_compliance_event',
    operator: 'any'
  },

  { id: 'non_compliance_event.non_compliance.place_id', name: 'local/pessoa', entity: 'forms_non_compliance_event' },
  { id: 'non_compliance_event.non_compliance.question_id', name: 'pergunta', entity: 'forms_non_compliance_event' },
  {
    id: 'non_compliance_event.non_compliance.question.tag_ids',
    name: 'tag da pergunta',
    entity: 'forms_non_compliance_event',
    operator: 'any'
  },
  {
    id: 'non_compliance_event.form_reply.form.checklist_id',
    name: 'questionário',
    entity: 'forms_non_compliance_event'
  },
  {
    id: 'non_compliance_event.form_reply.form_id',
    name: 'formulário',
    entity: 'forms_non_compliance_event'
  },
  { id: 'non_compliance_event.type', name: 'tipo', entity: 'forms_non_compliance_event' },
  {
    id: 'non_compliance.place.place_level_ids',
    name: 'nível de local',
    entity: 'forms_non_compliance_event',
    operator: 'any'
  }
]

const FieldSelect = ({ condition, index, conditions }) => {
  const form = useForm()
  const { t } = useTranslation('triggers')
  const { handleChangeIn } = useFormState()

  const filteredOptions = OPTIONS.filter(option => {
    const basicCondition = form.entity === option.entity
    let singleCondition
    if (option.single) {
      const conditionFound = conditions.find(cnd => cnd.field === option.id)
      if (conditionFound) {
        singleCondition = false
      } else {
        singleCondition = true
      }
    } else {
      singleCondition = true
    }

    return basicCondition && singleCondition
  })

  return (
    <EditableSentence
      label={condition.field ? t(`fields.${condition.field}`, condition.field) : '_________'}
      path={['conditions', index, 'field']}
      onChange={option => {
        handleChangeIn(['conditions', index, 'field'], option.id)
        handleChangeIn(['conditions', index, 'value'], undefined)
        handleChangeIn(['conditions', index, 'origin_value'], undefined)
        if (option.operator) handleChangeIn(['conditions', index, 'operator'], option.operator)
      }}
      options={filteredOptions}
    />
  )
}

export default FieldSelect
